module.exports = __webpack_public_path__ + "img/5ff64a2.png";